var x = function(y) {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var y = function(x) { return function() { return x; }; }
var __WEBPACK_NAMESPACE_OBJECT__ = x({ ["JSON_SCHEMA"]: function() { return __WEBPACK_EXTERNAL_MODULE_js_yaml_78384032__.JSON_SCHEMA; }, ["default"]: function() { return __WEBPACK_EXTERNAL_MODULE_js_yaml_78384032__["default"]; } });